import { render, staticRenderFns } from "./template-libs.vue?vue&type=template&id=600162bc&scoped=true"
import script from "./template-libs.vue?vue&type=script&lang=js"
export * from "./template-libs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600162bc",
  null
  
)

export default component.exports